<template>
  <div class="">
    <div class="section-title" style="text-align: center; margin: 40px 0;">
      Płatność
    </div>
    <v-container class="container mt-10" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="4" xl="3">
          <v-card shaped elevation="5" class="card">
            <v-container v-if="packageData" >
              <ValidationObserver
                v-if="packageData.active"
                ref="obs"
                v-slot="{ invalid, handleSubmit }"
                mode="eager"
              >
                <v-form  style="gap: 20px; padding: 30px; display: flex;flex-direction: column;" @submit.prevent="handleSubmit(onSubmit)">
                  <v-checkbox
                   color="#6D6963"
                    outlined
                    dense
                    v-model="invoiceForCompany"
                    :label="`Faktura na firmę`"
                    :disabled="loading || transaction.show"
                  ></v-checkbox>
                  <VTextFieldWithValidation
                    rules="email|required"
                    v-model.trim="email"
                    label="E-mail"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                  />
                  <VTextFieldWithValidation
                    rules="email|required"
                    v-model.trim="email_confirmation"
                    label="Potwierdź e-mail"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                  />
                  <VTextFieldWithValidation
                    :rules="!invoiceForCompany ? 'required' : ''"
                    v-if="!invoiceForCompany"
                    v-model="name"
                    label="Imię i nazwisko"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                  />
                  <VTextFieldWithValidation
                    :rules="invoiceForCompany ? 'required' : ''"
                    v-if="invoiceForCompany"
                    label="Nazwa firmy"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                    v-model="companyName"
                  />
                  <VTextFieldWithValidation
                    v-if="invoiceForCompany"
                    :rules="invoiceForCompany ? 'required|numeric|NIP' : ''"
                    label="Numer NIP"
                    placeholder="Wpisz numer NIP..."
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                    v-model="companyNIP"
                  />
                  <VTextAreaWithValidation
                    :rules="invoiceForCompany ? 'required' : ''"
                    :label="'Ad\u200Bres'"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                    v-model="address"
                    :height="80"
                    v-if="invoiceForCompany"
                  />
                  <VTextFieldWithValidation
                    rules="numeric"
                    v-model="phone"
                    label="Numer telefonu"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading || transaction.show"
                  />
                  <v-checkbox
                   color="#6D6963"
                    v-model="newsletter"
                    :label="`Zapisz się do newslettera`"
                    :disabled="loading || transaction.show"
                  ></v-checkbox>


                  <div
                    v-show="!invalid || !transaction.show"
                    @click="reset"
                    style="cursor: pointer; margin-left: auto; font-size: 12px; color: #8B857D;"
                  >
                    Zresetuj formularz
                    <svg
                      width="21"
                      height="10"
                      viewBox="0 0 31 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z"
                        fill="#8B857D"
                      />
                    </svg>
                  </div>


 <div
                    v-if="transaction.data.p24_amount"
                    style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
                  >
                    <div
                      class="sub-title"
                      style="font-size: 20px; text-align: left;"
                    >
                      Cena po zatwierdzeniu kodu rabatowego:
                    </div>

                    <div style="color: #54514C; font-weight: 500;">
                      {{ (transaction.data.p24_amount / 100).toFixed(2) }} zł
                    </div>
                  </div>
                  <div
                    v-else
                    class=""
                    style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;"
                  >
                    <div
                      class="sub-title"
                      style="font-size: 20px; text-align: left;"
                    >
                      Całkowity koszt:
                    </div>

                    <div style="color: #54514C; font-weight: 500;">
                      {{ packageData.price }} zł
                    </div>
                  </div>

                  <div
                    style="display: flex;justify-content: center;"
                    class="submit-content"
                  >
                    <v-btn
                      type="submit"
                      color="#C5C0B9"
                      style="color: #8B857D; border-radius: 16px; text-transform: none;   padding: 18px 36px 18px 36px; height: 50px; margin: auto;"
                      :disabled="invalid || transaction.show"
                      :loading="loading"
                    >
                      Zatwierdź dane
                    </v-btn>
                  </div>

                

                  <form :action="PAYMENT_URL" method="post" id="form">
                    <input
                      type="hidden"
                      name="p24_session_id"
                      :value="transaction.data.p24_session_id"
                    />
                    <input
                      type="hidden"
                      name="p24_merchant_id"
                      :value="transaction.data.p24_merchant_id"
                    />
                    <input
                      type="hidden"
                      name="p24_pos_id"
                      :value="transaction.data.p24_pos_id"
                    />
                    <input
                      type="hidden"
                      name="p24_amount"
                      :value="transaction.data.p24_amount"
                    />
                    <input
                      type="hidden"
                      name="p24_currency"
                      :value="transaction.data.p24_currency"
                    />
                    <input
                      type="hidden"
                      name="p24_description"
                      :value="transaction.data.p24_description"
                    />
                    <input
                      type="hidden"
                      name="p24_country"
                      :value="transaction.data.p24_country"
                    />
                    <input
                      type="hidden"
                      name="p24_email"
                      :value="transaction.data.p24_email"
                    />
                    <input
                      type="hidden"
                      name="p24_url_return"
                      :value="transaction.data.p24_url_return"
                    />
                    <input
                      type="hidden"
                      name="p24_url_status"
                      :value="transaction.data.p24_url_status"
                    />
                    <input
                      type="hidden"
                      name="p24_api_version"
                      :value="transaction.data.p24_api_version"
                    />
                    <input
                      type="hidden"
                      name="p24_sign"
                      :value="transaction.data.p24_sign"
                    />
                    <v-btn
                      v-if="transaction.show"
                      type="submit"
                      class="mt-5 submit-button"
                      :loading="loading"
                    >
                      Dokonaj płatności
                    </v-btn>
                  </form>

                  <br />
                  <div class="agreements">
                    <p>
                      Jeśli chcesz skorzystać z płatności PAYPAL, kliknij
                      przycisk dokonaj płatności a następnie przejdź do zakładki
                      inne. Składając zamówienie, wyrażasz zgodę na dostarczenie
                      treści cyfrowych lub świadczenie usługi przed upływem
                      terminu do odstąpienia od umowy zawartej na odległość.
                      Potwierdzasz, że tym samym tracisz prawo do odstąpienia od
                      umowy.
                    </p>
                  </div>
                </v-form>
              </ValidationObserver>
              <div v-else>
                <p style="color:#8B857D; margin-bottom: 40px;">
                  Zajęcia obecnie są nieaktywne. Spróbuj ponownie bliżej ich
                  rozpoczęcia.
                </p>

                <a
                  href="https://dagajoga.pl/index.php/zajecia-na-zywo/"
                  class="primary-button"
                  >OK</a
                >
              </div>
            </v-container>

            <v-container v-else class="mb-12">
              <h3 class="text-center" style="padding: 1rem">
                Przepraszamy, te warsztaty nie są już dostępne
              </h3>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VTextFieldWithValidation from "../../components/inputs/VTextFieldWithValidation";
import VTextAreaWithValidation from "../../components/inputs/VTextAreaWithValidation";
import { ValidationObserver } from "vee-validate";
import { PAYMENT_URL } from "../../axios";

export default {
  metaInfo: {
    title: "Dagajoga kurs online - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "TheoryPracticeWorkshopPayment",
  components: {
    VTextFieldWithValidation,
    ValidationObserver,
    VTextAreaWithValidation,
  },
  data: () => ({
    email: "",
    email_confirmation: "",
    name: "",
    phone: "",
    loading: false,
    PAYMENT_URL,
    newsletter: true,
    companyName: "",
    companyNIP: "",
    invoiceForCompany: false,
    address: "",
  }),
  computed: {
    transaction: function() {
      return this.$store.getters["payment/getTransInfo"];
    },
    packageData: function() {
      return this.$store.getters[
        "theoryPracticeWorkshops/getTheoryPracticeWorkshop"
      ];
    },
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
  },
  created() {
    this.resetData();
    this.$store.dispatch(
      "theoryPracticeWorkshops/fetchTheoryPracticeWorkshop",
      this.$route.params.id
    );
  },
  watch: {
    invoiceForCompany() {
      if (!this.companyNIP) {
        this.companyNIP = " ";
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("auth/fetchUserProfile");
    if (this.profile) {
      this.email = this.profile.email;
      this.email_confirmation = this.profile.email;
      if (this.profile.name) this.name = this.profile.name;
      if (this.profile.phone) this.phone = this.profile.phone;
      if (this.profile.company) this.companyName = this.profile.company;
      if (this.profile.nip) this.companyNIP = this.profile.nip;
      if (this.profile.address) this.address = this.profile.address;
    }
    const token = window.localStorage.getItem("userToken");
    if (!token) {
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "red",
          icon: "exclamation-triangle",
          message:
            "Zakup warsztatów teoria i praktyka dostępny jest wyłącznie dla zalogowanych użytkowników",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
      this.$router.push({
        name: "Auth",
        params: {
          previousPath: `/warsztaty-teoria-i-praktyka/platnosc/${this.$route.params.id}`,
        },
      });
    }
  },
  destroyed() {
    this.reset();
  },
  methods: {
    resetData() {
      this.$store.commit("payment/SET_INIT_VALUES");
      this.loading = false;
      this.email = "";
      this.email_confirmation = "";
      this.name = "";
      this.phone = "";
      this.newsletter = true;
      (this.address = ""), (this.companyNIP = ""), (this.companyName = "");
    },
    reset() {
      this.resetData();
      if (this.$refs.obs) {
        this.$refs.obs.reset();
      }
    },
    onSubmit() {
      if (
        (this.companyName && this.companyNIP && this.invoiceForCompany) ||
        (this.name && !this.invoiceForCompany)
      ) {
        this.loading = true;
        let object = {
          email: this.email,
          name: this.name,
          phone: this.phone,
          theoryPracticeWorkshopId: this.$route.params.id,
          newsletter: this.newsletter,
          confirmEmail: this.email_confirmation,
          companyName: this.companyName,
          nip: this.companyNIP,
          address: this.address,
          invoiceForCompany: this.invoiceForCompany,
        };
        this.$store
          .dispatch("payment/createTheoryPracticeWorkshopOrder", object)
          .then(() => {
            this.loading = false;
            this.$refs.obs.reset();
          });
      } else {
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message:
              'Musisz wypełnić przynajmniej jedno z następujących: "Imię i Nazwisko" bądź "Nazwa firmy" i "Numer NIP"',
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        if (this.$refs.obs) {
          this.$refs.obs.reset();
        }
      }
    },
  },
};
</script>


<style scoped>
.reset {
  text-transform: uppercase;
  cursor: pointer;
}
.submit-button {
  background-color: #8b857d !important;
  border-radius: 20px;
  font-size: 1.1rem;
  color: #d9d9d9;
  margin: auto;
  display: flex;
  justify-content: center;
}
.card {
  background: #d9d9d9;
  border-radius: 20px !important;
  box-shadow: 0px 0px 100px 25px #b6afa5 !important;
  color: #8b857d;
}
.agreements p {
  font-size: 12px;
}
.card{
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  width: 100%;
  box-shadow: 0px 0px 100px 25px #b6afa5;
}
</style>
